module.exports = __webpack_public_path__ + "static/media/newag_mlt_630_105_v_st4.106419e9.png";